import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { authService } from "Service/Axios";
import {
  ADD_NOTE_URL,
  DELETE_NOTE_URL,
  GET_ALL_NOTE_URL,
  UPDATE_NOTE_URL,
} from "Constant/api";
import { ISO_DATE } from "Constant/constants";
import { formatDateWithFullMonthTime } from "Utils";

export const PrivateNotes = ({ toggle }) => {
  const { t } = useTranslation();

  const [isAddNote, setIsAddNote] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [notesList, setNotesList] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    notes: "",
    gid: "",
  });
  const [errMsg, setErrMsg] = useState({
    title: "",
    notes: "",
  });

  // Toggle
  const toggleAdddNote = () => {
    setIsAddNote(!isAddNote);
  };

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (e.target.name === "title") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          title: t("common.messages.error.notes.title.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          title: "",
        }));
      }
    }
    if (e.target.name === "notes") {
      if (!e.target.value) {
        setErrMsg((prev) => ({
          ...prev,
          notes: t("common.messages.error.notes.notes.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          notes: "",
        }));
      }
    }
  };

  // List
  const getAllNotes = async () => {
    const payload = {};
    const response = await authService(GET_ALL_NOTE_URL, "POST", payload);
    setNotesList(response);
  };
  useEffect(() => {
    getAllNotes();
  }, []);

  const makeEditable = (note) => {
    setFormData({
      gid: note.gid,
      title: note.headline,
      notes: note.notes,
    });
    setIsEditMode(true);
    toggleAdddNote();
  };
  // Submit
  const onSaveNotes = async () => {
    if (!isEditMode) {
      const payload = {
        notes: formData.notes,
        headline: formData.title,
        creationDate: ISO_DATE,
      };
      await authService(ADD_NOTE_URL, "POST", payload);
    } else {
      const payload = {
        gid: formData.gid,
        notes: formData.notes,
        headline: formData.title,
        updateDate: ISO_DATE,
      };
      await authService(UPDATE_NOTE_URL, "POST", payload);
    }
    toggleAdddNote();
    setFormData({
      gid: "",
      title: "",
      notes: "",
    });
    getAllNotes();
  };

  const onPinnedNote = async (note) => {
    const payload = {
      gid: note.gid,
      notes: note.notes,
      headline: note.headline,
      updateDate: ISO_DATE,
      pinned: !note.pinned,
    };
    await authService(UPDATE_NOTE_URL, "POST", payload);
    getAllNotes();
  };

  const onDeleteNote = async (gid) => {
    const payload = {
      gid,
    };
    await authService(DELETE_NOTE_URL, "POST", payload);
    getAllNotes();
  };
  return (
    <div className="private-wrapper d-flex flex-column gap-2">
      <div className="search-div">
        <div className="input-group">
          <input
            type="search"
            className="form-control"
            placeholder={t("common.placeHolder.searchNote")}
          />
          <button type="button" className="input-group-text">
            <i className="pluto-search"></i>
          </button>
        </div>
      </div>
      <div className="private-note d-flex flex-column gap-2">
        <button type="button" className="add-note-btn px-4 py-2 h-auto" onClick={toggleAdddNote}>
          <i className="bx bxs-plus-circle"></i> {t("common.button.addNotes")}
        </button>
        {isAddNote && (
          <div className="add-note-box">
            <div className="add-note-headline">
              <input
                type="text"
                placeholder={t("common.placeHolder.title")}
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </div>
            <div className="write-notes-area">
              <textarea
                placeholder={t("common.placeHolder.description")}
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="note-btn">
              <button type="submit" className="button" onClick={onSaveNotes}>
                {t("common.button.save")}
              </button>
            </div>
          </div>
        )}
        <ul className="note-list">
          {notesList &&
            notesList.length > 0 &&
            notesList.map((note) => (
              <li key={note.gid}>
                <div className="note-box">
                  <div className="note-toggle">
                    <button
                      type="button"
                      className="dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bx bx-dots-horizontal-rounded"></i>
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <button
                          type="button"
                          onClick={() => makeEditable(note)}
                        >
                          <i className="bx bx-pencil"></i>
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          onClick={() => onPinnedNote(note)}
                        >
                          <i className="bx bx-pin"></i>
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          onClick={() => onDeleteNote(note.gid)}
                        >
                          <i className="bx bx-box"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="note-headline">
                    {note.headline}{" "}
                    <span className="note-date">
                      {formatDateWithFullMonthTime(
                        note.updateDate ? note.updateDate : note.creationDate
                      )}
                    </span>
                  </div>
                  <p>{note.notes}</p>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};
